import gql from 'graphql-tag'

export default gql`
query searchItems($_id: String!) {
  items(filter: {
    itemId: $_id
  }) {
    _id
    itemId
    product {
      name
      size
      color
    }
    label {
      recipient
      address
    }
    checkInAt
    checkInBy {
      name
    }
    checkOutAt
    checkOutBy {
      name
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchItems.js